import { FC } from 'react';
import { Box } from '@components';
import { InfoCard, NumberText } from '@builder';
import { StyledDiseaseTitle, StyledNoDataMessage, StyledRow, infoCardStyles } from './DiseaseCard.style';
import {
  StyledResultsPercentageText,
  StyledContentSeparator,
  StyledResultsPercentage,
  StyledColumn,
} from '../DiseasesSection.styles';
import { useTranslation } from 'react-i18next';
import { STUDY_INSIGHTS_TRANSLATION } from '@modules/study-insights/constants';
import { DiseaseCardProps } from './DiseaseCard.types';
import { Sizes, Weights } from '@/common/types';
import { COMMON_TRANSLATION } from '@/common/constants';

const DiseaseCard: FC<DiseaseCardProps> = ({
  icon,
  isDataAvailable,
  resultsNumber,
  resultsPercentage,
  title,
  testId,
}) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);

  return (
    <InfoCard css={infoCardStyles} hasBorder testId={`${testId}-disease`}>
      <StyledRow css={{ marginBottom: '$8' }}>
        <Box css={{ marginRight: '$4' }}>{icon}</Box>
        <StyledDiseaseTitle>{title}</StyledDiseaseTitle>
      </StyledRow>
      {isDataAvailable ? (
        <>
          <StyledRow css={{ marginBottom: '$5' }}>
            <NumberText size={Sizes.EXTRA_LARGE} weight={Weights.EXTRA_BOLD} testId={`${testId}-results-number`}>
              {resultsNumber}
            </NumberText>
            <StyledContentSeparator />
            <StyledColumn>
              <StyledResultsPercentage
                data-testid={`${testId}-results-percentage`}
              >{`${resultsPercentage}%`}</StyledResultsPercentage>
              <StyledResultsPercentageText>{t('of_patients')}</StyledResultsPercentageText>
            </StyledColumn>
          </StyledRow>
        </>
      ) : (
        <StyledNoDataMessage>{t('no_data_available', { ns: COMMON_TRANSLATION })}</StyledNoDataMessage>
      )}
    </InfoCard>
  );
};

export default DiseaseCard;
